import { styled } from "@mui/material/styles"
import { Popup as LPopup, Tooltip } from "react-leaflet"

import type { DefaultStyledProps } from "types/styled.types"

export const MarkerTooltip = styled(Tooltip)<DefaultStyledProps>(({ theme }) => ({
  border: "none",
  boxShadow: "none",
  borderRadius: "none",
  fontWeight: 600,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  "&:before": {
    opacity: 0,
  },
}))

// The entity card drawn inside a map popup. Leaflet's own frame goes, and the
// card lays out its content itself.
export const CardPopup = styled(LPopup)(({ theme }) => ({
  "& .leaflet-popup-content-wrapper": {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    boxShadow: theme.shadows[8],
    padding: 0,
  },
  "& .leaflet-popup-tip-container": {
    visibility: "hidden",
  },
  "& .leaflet-popup-content": {
    margin: 0,
    // Leaflet spaces paragraphs apart and colors every link.
    "& p": { margin: 0 },
    "& a": { color: theme.palette.primary.main },
  },
}))
